import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import * as AuthActions from '../actions/Auth';
import * as HeaderActions from '../actions/Header';
import * as PasswordActions from '../actions/Password';
import ForgotPasswordCode from '../components/ForgotPasswordCode';

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth,
    header: state.header,
    password: state.password,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    authActions: bindActionCreators(AuthActions, dispatch),
    headerActions: bindActionCreators(HeaderActions, dispatch),
    passwordActions: bindActionCreators(PasswordActions, dispatch),
  };
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgotPasswordCode) as any);



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordCode.tsx